/** Compatibility chooser shown only after the canonical context proves Local. */

import { type VerificationEnvironment } from "./env";

function localDeviceLabel(): "This Mac" | "This device" {
  if (typeof navigator !== "undefined" && /mac/i.test(navigator.platform)) return "This Mac";
  return "This device";
}

export function EnvChooser({
  onChoose,
}: {
  onChoose: (environment: VerificationEnvironment) => void;
}) {
  const label = localDeviceLabel();
  return (
    <div className="vp-env-chooser" data-env-chooser="" role="dialog" aria-modal="true" aria-labelledby="vp-env-chooser-title">
      <div className="vp-env-chooser-card">
        <h1 id="vp-env-chooser-title" className="vp-env-chooser-title">
          {label}
        </h1>
        <p className="vp-env-chooser-copy">
          Excellent observes this device automatically after the canonical Environment context
          verifies the local binding. Sample fixture data remains available only through the local
          verification lab.
        </p>
        <div className="vp-env-chooser-actions">
          <button
            type="button"
            className="vp-env-chooser-option"
            data-env-choose="this-mac"
            data-action-id="shell.env-choose-this-mac"
            onClick={() => onChoose("real")}
          >
            <span className="vp-env-chooser-option-label">Continue with {label}</span>
            <span className="vp-env-chooser-option-meta">Verified local Environment.</span>
          </button>
        </div>
      </div>
    </div>
  );
}
